export const QueryBrowserErrorLogs = {
  variable: '$condition: BrowserErrorLogQueryCondition',
  query: `
    queryBrowserErrorLogs(condition: $condition) {
        logs {
           message
           service
           serviceVersion
           time
           pagePath
           category
           errorUrl
           stack
           grade
        }
        total
    }`
};

export const GetProfileAnalyze = {
  variable: '$segmentId: String!, $timeRanges: [ProfileAnalyzeTimeRange!]!',
  query: `
  getProfileAnalyze: getProfileAnalyze(segmentId: $segmentId, timeRanges: $timeRanges) {
    tip
    trees {
      elements {
        id
        parentId
        codeSignature
        duration
        durationChildExcluded
        count
      }
    }
  }
  `
};
